if (!customElements.get('video-showroom')) {
  class VideoShowroom extends HTMLElement {
    constructor() {
      super();
      this.activeFilter = null;
      this.activeSubFilter = null;
    }

    connectedCallback() {
      this.filterButtons = this.querySelectorAll('[data-filter]');
      this.cards = this.querySelectorAll('[data-category]');
      this.subfiltersContainer = this.querySelector('[data-subfilters]');
      this.slider = this.querySelector('[data-slider]');
      this.prevBtn = this.querySelector('[data-slider-prev]');
      this.nextBtn = this.querySelector('[data-slider-next]');

      // Modal elements
      this.modal = this.querySelector('[data-modal]');
      this.modalClose = this.querySelector('[data-modal-close]');
      this.modalGallery = this.querySelector('[data-modal-gallery]');
      this.modalGalleryTag = this.querySelector('[data-modal-gallery-tag]');
      this.modalGalleryTitle = this.querySelector('[data-modal-gallery-title]');
      this.modalGalleryGrid = this.querySelector('[data-modal-gallery-grid]');
      this.modalPlayerView = this.querySelector('[data-modal-player-view]');
      this.modalPlayer = this.querySelector('[data-modal-player]');
      this.modalName = this.querySelector('[data-modal-name]');
      this.modalDesc = this.querySelector('[data-modal-desc]');
      this.modalTag = this.querySelector('[data-modal-tag]');
      this.modalBack = this.querySelector('[data-modal-back]');
      this.modalGalleryFilters = this.querySelector('[data-modal-gallery-filters]');
      this.modalShopLink = this.querySelector('[data-modal-shop-link]');

      this.bindCards();
      this.bindModal();
      this.bindSlider();
      this.applyFilter();
    }

    bindFilters() {
      this.filterButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var filter = btn.getAttribute('data-filter');
          this.activeFilter = filter === 'all' ? null : filter;
          this.activeSubFilter = null;

          this.filterButtons.forEach(function(b) { b.classList.remove('active'); });
          btn.classList.add('active');

          this.buildSubFilters();
          this.applyFilter();
          this.slider.scrollLeft = 0;
        }.bind(this));
      }.bind(this));
    }

    buildSubFilters() {
      this.subfiltersContainer.textContent = '';

      if (!this.activeFilter) return;

      var names = [];
      this.cards.forEach(function(card) {
        if (card.getAttribute('data-category') === this.activeFilter) {
          names.push(card.getAttribute('data-name'));
        }
      }.bind(this));

      if (names.length === 0) return;

      var allBtn = document.createElement('button');
      allBtn.className = 'video-showroom__subfilter-btn active';
      allBtn.setAttribute('data-subfilter', 'all');
      allBtn.textContent = 'All (' + names.length + ')';
      allBtn.addEventListener('click', function() {
        this.activeSubFilter = null;
        this.updateSubFilterActive();
        this.applyFilter();
        this.slider.scrollLeft = 0;
      }.bind(this));
      this.subfiltersContainer.appendChild(allBtn);

      names.forEach(function(name) {
        var btn = document.createElement('button');
        btn.className = 'video-showroom__subfilter-btn';
        btn.setAttribute('data-subfilter', name);
        btn.textContent = name;
        btn.addEventListener('click', function() {
          this.activeSubFilter = name;
          this.updateSubFilterActive();
          this.applyFilter();
          this.slider.scrollLeft = 0;
        }.bind(this));
        this.subfiltersContainer.appendChild(btn);
      }.bind(this));
    }

    updateSubFilterActive() {
      var btns = this.subfiltersContainer.querySelectorAll('[data-subfilter]');
      btns.forEach(function(btn) {
        var val = btn.getAttribute('data-subfilter');
        if ((!this.activeSubFilter && val === 'all') || val === this.activeSubFilter) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      }.bind(this));
    }

    applyFilter() {
      var shownCategories = {};

      this.cards.forEach(function(card) {
        var category = card.getAttribute('data-category');
        var name = card.getAttribute('data-name');

        if (!this.activeFilter) {
          // "All" mode: show only 1 card per category
          if (!shownCategories[category]) {
            shownCategories[category] = true;
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        } else {
          var categoryMatch = category === this.activeFilter;
          var subMatch = !this.activeSubFilter || name === this.activeSubFilter;

          if (categoryMatch && subMatch) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        }
      }.bind(this));

      this.updateArrows();
    }

    bindSlider() {
      this.prevBtn.addEventListener('click', function() {
        var cardWidth = this.getCardScrollAmount();
        this.slider.scrollBy({ left: -cardWidth, behavior: 'smooth' });
      }.bind(this));

      this.nextBtn.addEventListener('click', function() {
        var cardWidth = this.getCardScrollAmount();
        this.slider.scrollBy({ left: cardWidth, behavior: 'smooth' });
      }.bind(this));

      this.slider.addEventListener('scroll', function() {
        this.updateArrows();
      }.bind(this));

      window.addEventListener('resize', function() {
        this.updateArrows();
      }.bind(this));
    }

    getCardScrollAmount() {
      var visibleCard = this.slider.querySelector('.video-showroom__card:not([style*="display: none"])');
      if (!visibleCard) return 300;
      return visibleCard.offsetWidth + 12;
    }

    updateArrows() {
      var self = this;
      requestAnimationFrame(function() {
        var sl = self.slider;
        var hasOverflow = sl.scrollWidth > sl.clientWidth + 2;
        var atStart = sl.scrollLeft <= 1;
        var atEnd = sl.scrollLeft + sl.clientWidth >= sl.scrollWidth - 1;

        self.prevBtn.classList.toggle('hidden', !hasOverflow || atStart);
        self.nextBtn.classList.toggle('hidden', !hasOverflow || atEnd);
      });
    }

    /* ── Card click → open gallery ── */

    bindCards() {
      this.cards.forEach(function(card) {
        card.addEventListener('click', function() {
          this.openGallery(card);
        }.bind(this));
      }.bind(this));
    }

    getRelatedCards(category) {
      var related = [];
      this.cards.forEach(function(card) {
        if (card.getAttribute('data-category') === category) {
          related.push({
            name: card.getAttribute('data-name'),
            desc: card.getAttribute('data-desc'),
            youtubeId: card.getAttribute('data-youtube-id'),
            color: card.getAttribute('data-color'),
            category: card.getAttribute('data-category'),
            productLink: card.getAttribute('data-product-link')
          });
        }
      });
      return related;
    }

    buildGalleryCard(item) {
      var card = document.createElement('div');
      card.className = 'video-showroom__gallery-card';

      var inner = document.createElement('div');
      inner.className = 'video-showroom__gallery-card-inner';

      var img = document.createElement('img');
      img.className = 'video-showroom__gallery-card-thumb';
      img.src = 'https://i.ytimg.com/vi/' + item.youtubeId + '/oar2.jpg';
      img.alt = item.name;
      img.loading = 'lazy';

      var play = document.createElement('div');
      play.className = 'video-showroom__gallery-card-play';
      play.textContent = '▶';

      var overlay = document.createElement('div');
      overlay.className = 'video-showroom__gallery-card-overlay';

      var h3 = document.createElement('h3');
      h3.className = 'video-showroom__gallery-card-name';
      h3.textContent = item.name;

      var p = document.createElement('p');
      p.className = 'video-showroom__gallery-card-desc';
      p.textContent = item.desc;

      overlay.appendChild(h3);
      overlay.appendChild(p);

      var cardUrl = item.productLink;
      if (cardUrl) {
        var link = document.createElement('a');
        link.className = 'video-showroom__gallery-card-link';
        link.href = cardUrl;
        link.textContent = 'Shop this model →';
        link.addEventListener('click', function(e) {
          e.stopPropagation();
        });
        overlay.appendChild(link);
      }

      inner.appendChild(img);
      inner.appendChild(play);
      inner.appendChild(overlay);
      card.appendChild(inner);

      card.addEventListener('click', function() {
        this.openPlayer(item);
      }.bind(this));

      return card;
    }

    openGallery(clickedCard) {
      var category = clickedCard.getAttribute('data-category');
      var color = clickedCard.getAttribute('data-color');
      this._galleryCategory = category;
      this._galleryColor = color;
      this._galleryItems = this.getRelatedCards(category);
      this._galleryActiveFilter = null;
      this.resetModalClass();

      this.modalGalleryTag.textContent = category;
      this.modalGalleryTag.style.backgroundColor = color;
      this.modalGalleryTitle.textContent = category + ' videos (' + this._galleryItems.length + ')';

      this.buildGalleryFilters();
      this.renderGalleryGrid();

      this.modalGallery.hidden = false;
      this.modalPlayerView.hidden = true;
      this.modal.hidden = false;
      document.body.style.overflow = 'hidden';

      this._handleKey = function(e) {
        if (e.key === 'Escape') this.closeModal();
      }.bind(this);
      window.addEventListener('keydown', this._handleKey);
    }

    buildGalleryFilters() {
      this.modalGalleryFilters.textContent = '';
      var items = this._galleryItems;
      var names = [];
      items.forEach(function(item) {
        if (names.indexOf(item.name) === -1) names.push(item.name);
      });

      if (names.length <= 1) return;

      var allBtn = document.createElement('button');
      allBtn.className = 'video-showroom__subfilter-btn active';
      allBtn.textContent = 'All (' + items.length + ')';
      allBtn.addEventListener('click', function() {
        this._galleryActiveFilter = null;
        this.updateGalleryFilterActive();
        this.renderGalleryGrid();
      }.bind(this));
      this.modalGalleryFilters.appendChild(allBtn);

      names.forEach(function(name) {
        var btn = document.createElement('button');
        btn.className = 'video-showroom__subfilter-btn';
        btn.textContent = name;
        btn.addEventListener('click', function() {
          this._galleryActiveFilter = name;
          this.updateGalleryFilterActive();
          this.renderGalleryGrid();
        }.bind(this));
        this.modalGalleryFilters.appendChild(btn);
      }.bind(this));
    }

    updateGalleryFilterActive() {
      var btns = this.modalGalleryFilters.querySelectorAll('.video-showroom__subfilter-btn');
      var activeFilter = this._galleryActiveFilter;
      var index = 0;
      btns.forEach(function(btn) {
        if (index === 0) {
          btn.classList.toggle('active', !activeFilter);
        } else {
          btn.classList.toggle('active', btn.textContent === activeFilter);
        }
        index++;
      });
    }

    renderGalleryGrid() {
      this.modalGalleryGrid.textContent = '';
      var filter = this._galleryActiveFilter;
      this._galleryItems.forEach(function(item) {
        if (!filter || item.name === filter) {
          this.modalGalleryGrid.appendChild(this.buildGalleryCard(item));
        }
      }.bind(this));
    }

    openPlayer(item) {
      var content = this.modal.querySelector('.video-showroom__modal-content');
      this.modalPlayer.textContent = '';
      this.modalPlayer.appendChild(this.createYouTubeEmbed(item.youtubeId));
      this.modalName.textContent = item.name;
      this.modalDesc.textContent = item.desc;
      this.modalTag.textContent = item.category;
      this.modalTag.style.backgroundColor = item.color;

      var shopUrl = item.productLink;
      if (shopUrl) {
        this.modalShopLink.href = shopUrl;
        this.modalShopLink.hidden = false;
      } else {
        this.modalShopLink.hidden = true;
      }

      content.classList.remove('video-showroom__modal-content--gallery');
      content.classList.add('video-showroom__modal-content--player');
      this.modalGallery.hidden = true;
      this.modalPlayerView.hidden = false;
    }

    goBackToGallery() {
      var content = this.modal.querySelector('.video-showroom__modal-content');
      this.modalPlayer.textContent = '';
      content.classList.remove('video-showroom__modal-content--player');
      content.classList.add('video-showroom__modal-content--gallery');
      this.modalPlayerView.hidden = true;
      this.modalGallery.hidden = false;
    }

    buildProductUrl(category, name) {
      var collections = {
        'Road': 'road-bikes',
        'E-Bike': 'e-bikes',
        'MTB': 'mtb-bikes',
        'Gravel': 'gravel-bikes'
      };
      var slug = collections[category];
      if (!slug || !name) return '';
      return 'https://twitterbikeusa.com/collections/' + slug + '?filter.p.m.custom.model_name=' + encodeURIComponent(name) + '&sort_by=manual';
    }

    createYouTubeEmbed(youtubeId) {
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(youtubeId) + '?autoplay=1&loop=1&playlist=' + encodeURIComponent(youtubeId) + '&rel=0&modestbranding=1';
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'autoplay; encrypted-media');
      iframe.setAttribute('allowfullscreen', '');
      return iframe;
    }

    resetModalClass() {
      var content = this.modal.querySelector('.video-showroom__modal-content');
      content.classList.remove('video-showroom__modal-content--player');
      content.classList.add('video-showroom__modal-content--gallery');
    }

    closeModal() {
      this.modal.hidden = true;
      this.resetModalClass();
      this.modalPlayer.textContent = '';
      document.body.style.overflow = '';
      if (this._handleKey) {
        window.removeEventListener('keydown', this._handleKey);
      }
    }

    bindModal() {
      this.modalClose.addEventListener('click', function() { this.closeModal(); }.bind(this));
      this.modalBack.addEventListener('click', function() { this.goBackToGallery(); }.bind(this));
      this.modal.addEventListener('click', function(e) {
        if (e.target === this.modal) this.closeModal();
      }.bind(this));
    }
  }

  customElements.define('video-showroom', VideoShowroom);
}
